import styled from '@emotion/styled'
import { node } from 'prop-types'

export const FormWrapper = styled.div`
	display: block;
	height: 100%;
	width: 100%;
`

FormWrapper.propTypes = {
	children: node,
}
